import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CircleSlash } from 'lucide-react';
import { Button } from '@/shared/ui/buttons/Button';

export const WidgetsNotFoundMain = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <CircleSlash className="h-12 w-12 text-ink-faint" aria-hidden />
        <h1 className="text-xl font-semibold text-ink">{t('notFound.title')}</h1>
        <p className="text-sm text-ink-muted">{t('notFound.description')}</p>
        <Button onClick={() => navigate('/parcels')} className="mt-3">
          {t('notFound.goHome')}
        </Button>
      </div>
    </div>
  );
};
